module.exports = __webpack_public_path__ + "static/media/1.cb7c2763.png";